module.exports = __webpack_public_path__ + "assets/img/tether.59aaac09.svg";